import React from 'react'

import { alpha, Box, useTheme } from '@mui/material'

/**
 * The small brand-tinted count pill — "3" beside a filter facet's label
 * (`FilterField`), "N" beside a bulk-selection count (the Ask panel's history
 * multi-select bar). Extracted 2026-08-27 (VRG-227) on the second hand-roll
 * (working-conventions §36): `FilterField` had this inline first, and the Ask
 * panel needed the identical treatment rather than a differently-sized string
 * hand-rolled a second time.
 *
 * Renders nothing when `count` is 0 or less — the common "nothing selected"
 * case, handled here so no call site has to guard it.
 */
export const CountBadge = ({ count }: { count: number }) => {
  const theme = useTheme()
  if (count <= 0) return null

  return (
    <Box
      sx={{
        minWidth: 18,
        height: 18,
        px: 1,
        borderRadius: '999px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1,
        flexShrink: 0,
        color: theme.palette.brand[600],
        backgroundColor: alpha(theme.palette.brand[500], 0.12),
      }}
    >
      {count}
    </Box>
  )
}
